import React from "react";
import DfoUpdateLayerCustom from "../components/DfoUpdateLayerCustom";
import MasterLayout from "../masterLayout/MasterLayout";
import { useParams } from "react-router-dom"; // Import useParams

const DfoUpdatePage = () => {
    const { id } = useParams(); // Get the id from the URL parameters
  
  return (
    <>
      <MasterLayout>
      {/* SignUpLayer */}
      <DfoUpdateLayerCustom dfoId={id} />
      </MasterLayout>
    </>
  );
};

export default DfoUpdatePage; 
